<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            title2="校友详情"
            title3="编辑校友信息"
          ></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <!-- <div> -->
          <div class="mainTitle">
            <p class="userName">编辑 {{ ais_info.name_cn }} 的信息</p>
            <p class="userName_">
              在后台页面中，大批量的数据修改和提交是很常见的情况。
            </p>
          </div>
          <div class="mainbody">
            <h3 class="title">联系信息管理</h3>
            <div class="aLine"></div>

            <div class="contact_info">
              <div class="input_parent">
                <p>电话:</p>
                <el-input
                  class="input"
                  v-model="ais_info.mobile_phone"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_parent">
                <p>常用邮箱:</p>
                <el-input
                  class="input"
                  v-model="ais_info.active_email"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_parent">
                <p>微信号:</p>
                <el-input
                  class="input"
                  v-model="ais_info.wechat"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div class="input_parent">
                <p>校友类别:</p>
                <el-select
                  class="input"
                  v-model="ais_info.alumni_type"
                  placeholder="请选择"
                  collapse-tags
                >
                  <el-option
                    v-for="item in alumniTypeOptions"
                    :key="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="input_parent">
                <p>毕业时间:</p>
                <el-date-picker
                  class="input"
                  v-model="ais_info.graduation_year"
                  type="month"
                  placeholder="选择月"
                >
                </el-date-picker>
              </div>
            </div>

            <h3 class="title tableInfo_margin">深造信息管理</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="ais_education" :key="updateTimeStamp">
                <el-table-column
                  prop="education_status"
                  label="状态"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="location"
                  label="所在地"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="education_school"
                  label="院校名称"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="education_programme"
                  label="院校专业"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="education_graduation_year"
                  label="毕业年份"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="education_other"
                  label="其他"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="1"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="editEducation(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="text"
                      @click="deleteEducation(scope.$index, ais_education)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor">
                <el-button
                  @click="addEducation()"
                  type="text"
                  class="addData_style"
                  >+&nbsp;&nbsp;新增深造信息</el-button
                >
              </div>
            </div>
            <h3 class="title tableInfo_margin">工作信息管理</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="ais_job_info">
                <el-table-column
                  prop="status"
                  label="状态"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="location"
                  label="所在地"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="organization"
                  label="单位名称"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="unit_property"
                  label="单位性质"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="job_type"
                  label="行业类型"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="position"
                  label="工作职位"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="pay"
                  label="薪酬范围"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="registered_address"
                  label="公司注册地"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="employees"
                  label="雇员人数"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="turnover"
                  label="年营业额"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="freelance"
                  label="从事何种自由职业"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="2"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="editJobInfo(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="text"
                      @click="deleteJobInfo(scope.$index, ais_job_info)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor">
                <el-button
                  @click="addJobInfo()"
                  type="text"
                  class="addData_style"
                  >+&nbsp;&nbsp;新增个人工作信息</el-button
                >
              </div>
            </div>
            <h3 class="title tableInfo_margin">捐助信息管理</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="ais_journal">
                <el-table-column
                  prop="idshow"
                  label="ID"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="journal_time"
                  label="捐助时间"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="捐助内容"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="money"
                  label="捐助金额"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="type"
                  label="捐助类型"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="remark"
                  label="备注"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="2"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="editJournal(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="text"
                      @click="deleteJournal(scope.$index, ais_journal)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor">
                <el-button
                  @click="addJournal()"
                  type="text"
                  class="addData_style"
                  >+&nbsp;&nbsp;新增捐助信息</el-button
                >
              </div>
            </div>
            <h3 class="title tableInfo_margin">荣誉信息管理</h3>
            <div class="aLine"></div>
            <div class="tableInfo">
              <el-table :data="ais_honor">
                <el-table-column
                  prop="idshow"
                  label="ID"
                  min-width="1"
                ></el-table-column>
                <el-table-column
                  prop="honor_time"
                  label="荣誉时间"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="荣誉内容"
                  min-width="2"
                ></el-table-column>
                <el-table-column
                  prop="operating"
                  label="操作"
                  min-width="1"
                  align="left"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="text"
                      @click="editHonor(scope.$index, scope.row)"
                      >编辑</el-button
                    >
                    <el-button
                      size="mini"
                      type="text"
                      @click="deleteHonor(scope.$index, ais_honor)"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
              <div class="addData_bor" style="margin-bottom: 100px">
                <el-button @click="addHonor()" type="text" class="addData_style"
                  >+&nbsp;&nbsp;新增荣誉信息</el-button
                >
              </div>
            </div>
          </div>
          <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
          <!-- </div> v-for="(ais_info,index) in sons" :key="index" -->
        </el-main>

        <add-edit-edu-dialog
          ref="_addEditEduDialog"
          @toSave="$toSaveEdit"
        ></add-edit-edu-dialog>
        <add-edit-job-dialog
          ref="_addEditJobDialog"
          @toSave="$toSaveEdit"
        ></add-edit-job-dialog>
        <add-edit-journal-dialog
          ref="_addEditJournalDialog"
          @toSave="$toSaveEdit"
        ></add-edit-journal-dialog>
        <add-edit-honor-dialog
          ref="_addEditHonorDialog"
          @toSave="$toSaveEdit"
        ></add-edit-honor-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import { URL_PATH } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import FootLayout from "@/components/layout/footLayout";
import headerLayout from "@/components/layout/headerLayout";
import addEditInfoDialog from "@/components/dialog/addEditInfoDialog";
import addEditEduDialog from "@/components/dialog/addEditEduDialog";
import addEditJobDialog from "@/components/dialog/addEditJobDialog";
import addEditJournalDialog from "@/components/dialog/addEditJournalDialog";
import addEditHonorDialog from "@/components/dialog/addEditHonorDialog";

var del_ais_education = [];
var del_ais_job_info = [];
var del_ais_journal = [];
var del_ais_honor = [];

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    FootLayout,
    addEditEduDialog,
    addEditJobDialog,
    addEditJournalDialog,
    addEditHonorDialog,
  },
  data() {
    return {
      tableLoading: false,
      meunItem: null,
      meunTitle: "编辑校友信息",
      URL_PATH: URL_PATH,
      // editToken: "", //编辑用户信息的token
      ais_info: {}, //个人信息
      updateTimeStamp: "",
      ais_education: [], //深造信息
      ais_job_info: [], // 工作列表
      ais_journal: [], //捐助信息
      ais_honor: [], //荣誉信息
      labelPosition: "top",
      aisInfoStatusOptions: Constant.work_status_options,
      alumniTypeOptions: [],
      sons: {},
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      // this.userid = this.meunItem.userid;
      // console.log(this.userid);
      // console.log(this.ais_info);
      this.getInfo();
    },
    // 编辑
    saveEdit() {
      let updateWechat = StrUtils.isEmpty(this.ais_info.wechat) == false;
      if (
        updateWechat &&
        (this.ais_info.wechat.length < 6 || this.ais_info.wechat.length > 20)
      ) {
        this.$message.error("微信限制6-20个字符");
        return;
      }
      this.putDelAisInfo();
      this.$api
        .updateAisById(
          {
            // token: localStorage.getItem("token"),
            id: this.ais_info.id,
            ais_info: JSON.stringify(this.ais_info),
            ais_education: JSON.stringify(this.ais_education),
            ais_job_info: JSON.stringify(this.ais_job_info),
            ais_journal: JSON.stringify(this.ais_journal),
            ais_honor: JSON.stringify(this.ais_honor),
            // photo: photo
          },
          localStorage.getItem("token")
        )
        .then(({ data }) => {
          console.log(data);
          if (data.Code != 0) {
            this.$message.error(data.Msg);
          } else {
            this.$router.go(0);
          }
        })
        .catch(({ error }) => {
          // this.$message.error(error);
        });
    },
    // 添加已清除的数据到列表
    putDelAisInfo() {
      if (del_ais_education.length > 0) {
        del_ais_education.forEach((element) => {
          this.ais_education.push(element);
        });
        del_ais_education = [];
      }
      if (del_ais_job_info.length > 0) {
        del_ais_job_info.forEach((element) => {
          this.ais_job_info.push(element);
        });
        del_ais_job_info = [];
      }
      if (del_ais_journal.length > 0) {
        del_ais_journal.forEach((element) => {
          this.ais_journal.push(element);
        });
        del_ais_journal = [];
      }
      if (del_ais_honor.length > 0) {
        del_ais_honor.forEach((element) => {
          this.ais_honor.push(element);
        });
        del_ais_honor = [];
      }
    },
    getAlumniTypeOptions() {
      this.$api
        .bindAisInfoFieldArr({ field: "alumni_type" })
        .then(({ data }) => {
          // console.log(data);
          this.alumniTypeOptions = data.Data.alumni_type;
        })
        .catch(({ error }) => {
          console.log(error);
        });
    },
    // 获取基础信息
    getAisInfoById: function () {
      this.tableLoading = true;
      this.$api
        .getAisInfoById({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
            if (data.Data.id != this.$route.query.id) {
            this.ais_info = data.Data.son;
            this.ais_info.forEach(info => {
              this.ais_info = info
            })
          } else {
            this.ais_info = data.Data;
          }
            console.log(this.ais_info);
          this.tableLoading = false;
        })
        .catch(({ error }) => {
          this.$message.error(error);
          this.tableLoading = false;
        });
    },
    // 获取工作信息
    getAisJobInfoById: function () {
      this.$api
        .getAisJobInfoById({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          // console.log(data);
          // 获取校友工作信息列表
          this.ais_job_info = data.Data;
          // this.ais_info = data.Data.son;

          this.ais_job_info.forEach((element) => {
            element.location = StrUtils.getJobLocation(element);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取深造信息
    getAisEducationById: function () {
      this.$api
        .getAisEducationById({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.ais_education = data.Data;
          this.ais_education.forEach((element) => {
            element.location = StrUtils.getEduLocation(element);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取捐助信息
    getAisJournalById: function () {
      this.$api
        .getAisJournalById({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.ais_journal = data.Data;
          this.ais_journal.forEach((element) => {
            element.idshow = element.id.substring(
              element.id.length - 6,
              element.id.length
            );
          });
        })
        .catch(({ error }) => {});
    },
    // 获取荣誉信息
    getAisHonorById: function () {
      this.$api
        .getAisHonorById({
          token: localStorage.getItem("token"),
          id: this.$route.query.id,
        })
        .then(({ data }) => {
          this.ais_honor = data.Data;
          this.ais_honor.forEach((element) => {
            element.idshow = element.id.substring(
              element.id.length - 6,
              element.id.length
            );
          });
          // console.log(data);
        })
        .catch(({ error }) => {});
    },
    getInfo: function () {
      this.getAlumniTypeOptions();
      this.getAisInfoById();
      this.getAisJobInfoById();
      this.getAisEducationById();
      this.getAisJournalById();
      this.getAisHonorById();
    },
    // 编辑深造信息
    editEducation(index, info) {
      this.addEducation(index, info);
    },
    // 删除深造信息
    deleteEducation(index, rows) {
      var delInfo = this.ais_education[index];
      delInfo.delete_time = new Date().getTime() / 1000;
      del_ais_education.push(delInfo);
      this.ais_education.splice(index, 1);
    },
    // 新增深造信息
    addEducation(index, info) {
      var userName = this.ais_info.name_cn;
      this.$nextTick(() => {
        this.$refs._addEditEduDialog.show(
          index,
          userName,
          "ais_education",
          info
        );
      });
    },
    // 编辑工作信息
    editJobInfo(index, info) {
      this.addJobInfo(index, info);
    },
    // 删除工作信息
    deleteJobInfo(index, rows) {
      var delInfo = this.ais_job_info[index];
      delInfo.delete_time = new Date().getTime() / 1000;
      del_ais_job_info.push(delInfo);
      this.ais_job_info.splice(index, 1);
    },
    // 新增工作信息
    addJobInfo(index, info) {
      var userName = this.ais_info.name_cn;
      this.$nextTick(() => {
        this.$refs._addEditJobDialog.show(
          index,
          userName,
          "ais_job_info",
          info
        );
      });
    },
    // 编辑捐助信息
    editJournal(index, info) {
      this.addJournal(index, info);
    },
    // 删除捐助信息
    deleteJournal(index, rows) {
      var delInfo = this.ais_journal[index];
      delInfo.delete_time = new Date().getTime() / 1000;
      del_ais_journal.push(delInfo);
      this.ais_journal.splice(index, 1);
    },
    // 新增捐助信息
    addJournal(index, info) {
      var userName = this.ais_info.name_cn;
      this.$nextTick(() => {
        this.$refs._addEditJournalDialog.show(
          index,
          userName,
          "ais_journal",
          info
        );
      });
    },
    // 编辑荣誉信息
    editHonor(index, info) {
      this.addHonor(index, info);
    },
    // 删除荣誉信息
    deleteHonor(index, rows) {
      var delInfo = this.ais_honor[index];
      delInfo.delete_time = new Date().getTime() / 1000;
      del_ais_honor.push(delInfo);
      this.ais_honor.splice(index, 1);
    },
    // 新增荣誉信息
    addHonor(index, info) {
      var userName = this.ais_info.name_cn;
      this.$nextTick(() => {
        this.$refs._addEditHonorDialog.show(index, userName, "ais_honor", info);
      });
    },
    // 编辑或添加保存
    $toSaveEdit(index, type, info) {
      console.log(index);
      console.log(type);
      console.log(JSON.stringify(info));
      this.updateTimeStamp == new Date().getTime();
      switch (type) {
        case "ais_education": // 深造信息
          if (index == undefined) {
            this.ais_education.unshift(info);
          } else {
            // this.$set(this.ais_education, index, info);
            this.ais_education.splice(index, 1);
            this.ais_education.unshift(info);
          }
          break;
        case "ais_job_info": // 工作信息
          if (index == undefined) {
            this.ais_job_info.unshift(info);
          } else {
            // this.$set(this.ais_job_info, index, info);
            this.ais_job_info.splice(index, 1);
            this.ais_job_info.unshift(info);
          }
          break;
        case "ais_journal": // 捐助信息
          if (index == undefined) {
            this.ais_journal.unshift(info);
          } else {
            // this.$set(this.ais_journal, index, info);
            this.ais_journal.splice(index, 1);
            this.ais_journal.unshift(info);
          }
          break;
        case "ais_honor": // 荣誉信息
          if (index == undefined) {
            this.ais_honor.unshift(info);
          } else {
            // this.$set(this.ais_honor, index, info);
            this.ais_honor.splice(index, 1);
            this.ais_honor.unshift(info);
          }
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 10px;
  margin-top: -10px;
  margin-left: -20px;
  margin-right: -20px;
}
.mainTitle .userName {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
}
.mainTitle .userName_ {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.65);
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  margin-top: 24px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .contact_info {
  width: 100%;
  overflow: hidden;
}
.mainbody .input_parent {
  float: left;
  width: 32%;
  height: 100px;
}
.mainbody .input_parent p {
  float: left;
  width: 32%;
  margin-left: 32px;
  text-align: left;
}
.mainbody .input_parent .input {
  float: left;
  width: 90%;
  margin-left: 32px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.mainbody .tableInfo_margin {
  margin-top: 62px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.addData_bor {
  margin-top: 26px;
  border: 1px dashed #b1b1b1;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  text-align: center;
}
.addData_bor .addData_style {
  font-size: 14px;
  color: #848484;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  height: 32px;
}
</style>


// WEBPACK FOOTER //
// src/pages/dataMgr/editInfo1.vue